import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  change,
  submit as submitFormAction,
  getFormValues,
  destroy,
} from 'redux-form';
import { Modal, Button, Icon } from 'semantic-ui-react';
import moment from 'moment';

import { createToast, toastType } from 'Common/ToastHelper';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { UnApplyCycleMenuFieldEnum as Fields } from 'Common/FieldEnum';
import { UN_APPLY_CYCLE_MENU_FORM_NAME } from 'Common/FormEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import {
  saveCycleMenu,
  unApplyCycleMenu,
  checkApplyCycleMenu,
  getCycleMenuSites,
} from 'Pages/managemenu/state/editmenu/actions';
import {
  getIsApplying,
  getSites,
} from 'Pages/managemenu/state/editmenu/selectors';
import {
  DatePickerFilter,
  OnOrAfterDateFilterMethod,
  OnOrBeforeDateFilterMethod,
} from 'Common/GridHelper';

import { UnApplyCycleMenuForm } from './UnApplyCycleMenuForm';

import 'Styles/pages/managemenu/manageMenuModal.less';

const now = moment();
class UnApplyCycleMenuModal extends Component {
  async componentDidMount() {
    const { menuId, getCycleMenuSites } = this.props;
    await getCycleMenuSites(menuId);
  }

  commonHeaderStyles = {
    textAlign: 'left',
    marginLeft: 5,
    display: 'flex',
    alignItems: 'center',
    padding: '7px 0',
  };

  additionalColumns = [
    {
      Header: 'From',
      resizable: false,
      headerStyle: {
        ...this.commonHeaderStyles,
      },
      id: 'From',
      accessor: (d) => moment(d.From).format(DATE_FORMAT_FOR_UI),
      aggregate: (vals, rows) => {
        return vals[0];
      },
      Aggregated: (row) => {
        return <span>{moment(row.value).format(DATE_FORMAT_FOR_UI)}</span>;
      },
      filterMethod: OnOrAfterDateFilterMethod,
      Filter: (props) => {
        return <DatePickerFilter {...props} fluid={true} />;
      },
    },
    {
      Header: 'To',
      resizable: false,
      headerStyle: {
        ...this.commonHeaderStyles,
      },
      id: 'To',
      accessor: (d) => moment(d.To).format(DATE_FORMAT_FOR_UI),
      aggregate: (vals, rows) => {
        return vals[0];
      },
      Aggregated: (row) => {
        return <span>{moment(row.value).format(DATE_FORMAT_FOR_UI)}</span>;
      },
      filterMethod: OnOrBeforeDateFilterMethod,
      Filter: (props) => {
        return <DatePickerFilter {...props} fluid={true} />;
      },
    },
  ];

  unApplyCycleMenu = async () => {
    const { unApplyCycleMenu, formValues } = this.props;

    const [unApplied, message] = await unApplyCycleMenu(formValues);

    let successMessage = 'Cycle menu has been un-applied.';

    if (unApplied) {
      createToast(toastType.success, 'Success', successMessage, true);
      if (message) {
        createToast(toastType.info, 'Warning', message, true);
      }
    }
  };

  render() {
    const {
      menuId,
      numberOfDaysInCycle,
      headerTitle,
      isApplying,
      modalProps,
      formValues,
      submit,
      sites,
    } = this.props;
    const { onClose } = modalProps;

    return (
      <Modal {...modalProps}>
        <Modal.Header className="manage-menu-modal-header">
          {headerTitle}
          <Icon name="close" onClick={onClose} className="manage-menu-close" />
        </Modal.Header>
        <Modal.Content className="manage-menu-modal-content">
          <UnApplyCycleMenuForm
            initialValues={{
              [Fields.CycleMenuId]: menuId,
              [Fields.StartDateTime]: defaultDateFormat(now),
              [Fields.EndDateTime]: defaultDateFormat(now),
              [Fields.SiteIds]: [],
              [Fields.PublishMenu]: false,
              [Fields.NumberOfDaysInCycle]: numberOfDaysInCycle,
            }}
            sites={sites}
            formValues={formValues}
            onSubmit={this.unApplyCycleMenu}
            additionalColumns={this.additionalColumns}
          />
        </Modal.Content>
        <Modal.Actions>
          <div className="manage-menu-header-buttons">
            <Button
              className="mnm-button-blue"
              onClick={() => submit(UN_APPLY_CYCLE_MENU_FORM_NAME)}
              loading={isApplying}
              disabled={isApplying}
            >
              Un-Apply
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

const formValueSelector = getFormValues(UN_APPLY_CYCLE_MENU_FORM_NAME);

const mapStateToProps = (state) => ({
  isApplying: getIsApplying(state),
  formValues: formValueSelector(state),
  sites: getSites(state),
});

const mapDispatchToProps = {
  setNotificationDialog,
  saveCycleMenu,
  unApplyCycleMenu,
  submit: submitFormAction,
  checkApplyCycleMenu,
  change,
  destroy,
  getCycleMenuSites,
};

const ConnectedUnApplyCycleMenuModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(UnApplyCycleMenuModal);

export { ConnectedUnApplyCycleMenuModal as UnApplyCycleMenuModal };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/UnApplyCycleMenuModal.js